import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class SnackbarMessageNormalizerService {
  private initialized = false;

  init(): void {
    if (this.initialized) {
      return;
    }

    const prototype = MatSnackBar.prototype as MatSnackBar & {
      __normalizedOpenPatched?: boolean;
      open: (message: string, action?: string, config?: MatSnackBarConfig) => MatSnackBarRef<SimpleSnackBar>;
    };

    if (prototype.__normalizedOpenPatched) {
      this.initialized = true;
      return;
    }

    const originalOpen = prototype.open;
    prototype.open = function (
      message: string,
      action?: string,
      config?: MatSnackBarConfig
    ): MatSnackBarRef<SimpleSnackBar> {
      const normalizedMessage = SnackbarMessageNormalizerService.normalizeMessage(message);
      return originalOpen.call(this, normalizedMessage, action, config);
    };

    prototype.__normalizedOpenPatched = true;
    this.initialized = true;
  }

  private static normalizeMessage(message: string): string {
    if (typeof message !== 'string') {
      return message as unknown as string;
    }

    const trimmed = message.trim();
    if (!trimmed) {
      return message;
    }

    // Keep punctuation for multi-sentence messages.
    const sentenceParts = trimmed.split(/(?<=[.!?])\s+/).filter(Boolean);
    if (sentenceParts.length > 1) {
      return trimmed;
    }

    // Drop trailing period for single-sentence messages.
    return trimmed.endsWith('.') ? trimmed.slice(0, -1) : trimmed;
  }
}
